<app-loader></app-loader>
<ng-container *ngIf="!showNav">
  <router-outlet></router-outlet>
  <p-toast position="bottom-right">
    <ng-template let-message pTemplate="message">
      <div class="custom-toast">
        {{message.detail}}<a class="custom-toast-link" (click)="clear()">Dismiss</a>
      </div>
    </ng-template>
  </p-toast>
</ng-container>
<ng-container *ngIf="showNav">
  <div style="display: flex; flex-direction: column">
    <div class="navbar-left" [hidden]="!showTopNav || !showLeftNav">
      <!-- [style.background]="backgroundColor" -->
      <app-left-nav></app-left-nav>
    </div>
  </div>
  <div style="position: absolute; left: 0; top: 0; right: 0; bottom: 0;" [style.left]="showLeftNav ? '364px' : '0'">

    <div>
      <app-nav-menu></app-nav-menu>
    </div>
    <div class="body" [style.top]="showTopNav ? '96px' : '0'">
      <div class="main">
        <div class="content">
          <!-- [class.system-report]="letNavSelected?.child == 'weekly_reporting' || letNavSelected?.area == 'reporting' || letNavSelected?.child == 'tenders'" -->
          <div class="box system-report" >
            <div class="column system-report">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-toast position="bottom-right">
    <ng-template let-message pTemplate="message">
      <div class="custom-toast">
        {{message.detail}}<a class="link-button custom-toast-link" (click)="clear()">Dismiss</a>
      </div>
    </ng-template>
  </p-toast>
  <detail-modal></detail-modal>
</ng-container>